import Service from './Service'
export default class DesignInsightService extends Service {
  constructor () {
    super()
    this.paramsURL = {
      design: 'design.php'
    }
  }

  static parse (model) {
    const di = model
    di.showInfo = false
    di.selected = false
    di.turnOff = false
    return di
  }

  findAll (params, callbackSuccess, callbackHandleError) {
    let stringParams = '?'
    let i = 0
    for (const param in params) {
      if (i > 0) {
        stringParams += '&'
      }
      stringParams += param + '=' + params[param]
      i++
    }
    this.ajax('GET', this.paramsURL.design + stringParams, {}, callbackSuccess, callbackHandleError)
  }
}
